import React from "react";
import AttendanceMonthlyView from "./AttendanceMonthlyView";
import AttendanceYearlyView from "./AttendanceYearlyView";

export default function AttendancePeriodSection({
  activeTab,
  animateChart,
  brand,
  filteredStudents,
  handleJumpToDaily,
  handleYearMonthClick,
  isMobile,
  ListWrapper,
  monthlyData,
  sundaysInMonth,
  yearlyData,
}) {
  return (
    <ListWrapper
      className={`flex-1 flex flex-col ${isMobile ? "min-h-0 overflow-hidden !bg-transparent !border-none !shadow-none !mt-0" : "min-h-[600px] mt-4"}`}
      {...(!isMobile ? { noHover: true, allowOverflow: true } : {})}
    >
      <div className={`flex-1 overflow-auto custom-scrollbar ${isMobile ? "p-0" : "p-6"}`}>
        {activeTab === "monthly" ? (
          <AttendanceMonthlyView
            brand={brand}
            filteredStudents={filteredStudents}
            handleJumpToDaily={handleJumpToDaily}
            isMobile={isMobile}
            monthlyData={monthlyData}
            sundaysInMonth={sundaysInMonth}
          />
        ) : (
          <AttendanceYearlyView
            animateChart={animateChart}
            filteredStudents={filteredStudents}
            handleYearMonthClick={handleYearMonthClick}
            isMobile={isMobile}
            yearlyData={yearlyData}
          />
        )}
      </div>
    </ListWrapper>
  );
}
